export default "__VITE_ASSET__2b6d1b6a__"